import React from "react";
import { FaRegCircle } from "react-icons/fa";
import { FaCircleCheck } from "react-icons/fa6";
import { moduleitemCompDTO } from "../../../typings/uicomponents";

const ModuleItem: React.FC<moduleitemCompDTO> = ({
  selected,
  onSelected,
  icon,
  name,
}) => {
  return (
    <div
      onClick={onSelected}
      className="rounded-[16px] p-4 border flex   items-center border-gray-200 mt-4"
    >
      {selected ? (
        <FaCircleCheck className="inline text-primary" />
      ) : (
        <FaRegCircle className="inline text-gray-500" />
      )}
      {icon}

      <p className=" cursor-pointer text-sm text-gray-700 font-medium inline p-3">
        {name}
      </p>
    </div>
  );
};

export default ModuleItem;
